// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#mainMenu li {
	border-color: #185f7d;
	border-style: solid;
	border-width: 0 1px 0 0;
}

#mainMenu li:first-child {
	border-width: 0 1px;
}

#mainMenu li a {
	font-size: 1.5em;
	padding: .5em 1em !important;
}

#mainMenu li:hover {
	background-color: #185f7d;
}

#mainMenu li button {
	font-size: 1em;
	padding: .5em 1.25em !important;
}

#mainMenu .navbar-right {
	margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/main-nav/style.css"],"names":[],"mappings":";AACA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,+BAA+B;AAChC;;AAEA;CACC,eAAe;AAChB","sourcesContent":["\r\n#mainMenu li {\r\n\tborder-color: #185f7d;\r\n\tborder-style: solid;\r\n\tborder-width: 0 1px 0 0;\r\n}\r\n\r\n#mainMenu li:first-child {\r\n\tborder-width: 0 1px;\r\n}\r\n\r\n#mainMenu li a {\r\n\tfont-size: 1.5em;\r\n\tpadding: .5em 1em !important;\r\n}\r\n\r\n#mainMenu li:hover {\r\n\tbackground-color: #185f7d;\r\n}\r\n\r\n#mainMenu li button {\r\n\tfont-size: 1em;\r\n\tpadding: .5em 1.25em !important;\r\n}\r\n\r\n#mainMenu .navbar-right {\r\n\tmargin-right: 0;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
